import moment from 'moment'

export function makeTimetableFields (data) {
  let finalData = {
    start_time: moment(data.start_time, 'hh:mm:ss'),
    end_time: moment(data.end_time, 'hh:mm:ss'),
    teacher_id: data.teacher_id,
    subject_id: data.subject_id,
    type: data.type,
    type_value: data.type_value,
  }

  return finalData
}

export function makeTimetableGroupFields (data) {
  let finalData = {
    start_time: moment(data.start_time, 'hh:mm:ss'),
    end_time: moment(data.end_time, 'hh:mm:ss'),
    subject_id: data.group_subject_id,
    break: data.break,
  }

  return finalData
}

export function makeTimetableGroupSubjectsFields (data) {
  const finalData = {}
  data.group_subject_entries.forEach(function(element) {
    let subjectId = `subject_teachers[${element.subject_id}]subject_id`
    let teacherId = `subject_teachers[${element.subject_id}]teacher_id`

    finalData[subjectId] = element.subject_id
    finalData[teacherId] = element.teacher_id
  })

  return finalData
}

export function makeTimetableMultiFields (data) {
  let finalData = {
    start_time: moment(data.start_time, 'hh:mm:ss'),
    end_time: moment(data.end_time, 'hh:mm:ss'),
    break: data.break,
  }

  return finalData
}

export function makeTimetableMultiSubjectsFields (data) {
  const finalData = {}
  data.group_subject_entries.forEach(function(element, index) {
    let subjectId = `subject_teachers[${index}]subject_id`
    let teacherId = `subject_teachers[${index}]teacher_id`

    finalData[subjectId] = element.subject_id
    finalData[teacherId] = element.teacher_id
  })

  return finalData
}
